<template>
  <div class="box9">
    <pageTitle
      title="不贪多不念全&nbsp;&nbsp;精准定位靶向施策<br/>打造更多就业神奇"
      text="2025年整体就业环境焦灼，但他们的薪资却屡创新高！"
      titleColor="#1A0400"
      titColor="#665552"
      class="pageTitle"
    />
    <div class="subTitle"></div>
    <div class="content">
      <span class="content-item">
        <h2>11386元</h2>
        <p>最近40期<br />平均综合薪资</p>
      </span>
      <span class="content-item">
        <h2>100%</h2>
        <p>39期优秀毕业班级<br />就业率</p>
      </span>
      <span class="content-item">
        <h2>年薪36W</h2>
        <p>
          高年薪毕业生<br />
          “34期于同学”
        </p>
      </span>
    </div>
    <div class="swiper-content">
      <swiper
        :options="swiperOptionbox13"
        ref="mySwiperbox13"
        class="swiperitems"
      >
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in 3"
          :key="index"
        >
          <img
            :src="
              require(`../../../assets/coursePage/newMedia/box9/${
                index + 1
              }.png`)
            "
            alt
          />
        </swiper-slide>
      </swiper>

      <!-- <div class="swiper-pagination-box13"></div> -->
    </div>
    <p class="source">
      * 为了避免对学员造成影响，以上数据做了部分隐藏处理<br />
      相关数据来源于公司内部真实统计
    </p>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },

  data() {
    return {
      list: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      swiperOptionbox13: {
        loop: true, // 循环模式选项

        spaceBetween: 30,
        autoplay: false,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box13",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.pageTitle {
  padding: 0 32px;
}
.source {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #997f7a;
  line-height: 38px;
  text-align: center;
}
.box9 {
  padding: 80px 0 88px;

  width: 100%;
  background: #fefbf3;
  background-origin: center top;
  /deep/ .swiper-container-free-mode > .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
    margin: 0 auto;
  }
  .subTitle {
    background: url("../../../assets/coursePage/newMedia/box9/subtitle.png");
    width: 728px;
    background-size: cover;
    height: 112px;
    margin: 48px auto 20px;
    padding: 19px 217px 0 219px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    p {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 32px;
    }
  }
  .content {
    background: url("../../../assets/coursePage/newMedia/box9/content.png");
    width: 690px;
    height: 194px;

    background-size: contain;
    box-shadow: 0px 8px 40px 0px rgba(230, 101, 77, 0.12);
    display: flex;
    background-size: cover;
    margin: 0 auto;
    border-radius: 16px;
    padding: 44px 48px 0 38px;
    box-sizing: border-box;
    justify-content: space-between;
  }
  .content-item {
    display: block;

    background-size: contain;

    text-align: center;
    overflow: hidden;

    h2 {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ff5533;
      line-height: 44px;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9c8f86;
      margin-top: 8px;
      line-height: 36px;
    }
  }
  .swiper-content {
    position: relative;
    padding-bottom: 42px;
    margin-top: 40px;

    img {
      width: 586px;
      height: 579px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
      flex-shrink: 0;
    }

    .swiper-slide {
      display: flex;
      align-items: center;

      width: 586px;
      height: 663px;

      border-radius: 20px;
      box-sizing: border-box;
    }
    .swiper-slide-active {
      img {
        width: 586px;
        height: 663px;
        border-radius: 24px;

        object-fit: contain;
      }
    }
    .swiper-pagination-box13 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translate(-50%, 0px);
      height: 6px;
      background: #ffab9a;
      border-radius: 3px;
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #ffab9a;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #ff5731;
    border-radius: 3px;
  }
}
</style>
